import { Component, Input, OnInit,Output,EventEmitter } from '@angular/core';
import { CalendarEventModel } from 'src/app/shared/component/weekly-calendar/calendar-event-model';
import { LoaderService } from '../../services/loader.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbCalendar, NgbDate,NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-weekly-calendar',
  templateUrl: './weekly-calendar.component.html',
  styleUrls: ['./weekly-calendar.component.scss']
})
export class WeeklyCalendarComponent implements OnInit {
  @Input() 
    get events() : CalendarEventModel[] {return this._events};
    set events(events: CalendarEventModel[]){
      this._events = events;
      if(this._events.length){
        this.buildDateArray();
      }
      this.loaderService.display(false);

    }
  private _events : CalendarEventModel[] = [];
  @Output() selectedEventChange = new EventEmitter<CalendarEventModel | null>();
  @Output() dateChangeOccurred = new EventEmitter<Array<Date>>();
  currentDate : Date = new Date(new Date().setHours(0, 0, 0, 0));
  startDate: Date;
  endDate : Date;
  dateObjects: any[] = [];
  miniumNgbStartDate : NgbDate;
  NgbStartDate : NgbDate| null;
  NgbEndDate : NgbDate | null;
  hoveredDate: NgbDate | null = null;
 
  get disableTodayButton() : boolean { return (this.currentDate >= this.startDate && this.currentDate <= this.endDate)};

  constructor(private loaderService: LoaderService, private translate: TranslateService, private calendar:NgbCalendar,public formatter: NgbDateParserFormatter) { 
  }

  ngOnInit(): void {
    this.getStartRange();
  }

  getStartRange(){
    let today = this.calendar.getToday()
    this.getRange(today);
  }

  getRange(ngDate:NgbDate){
    let date = this.createDateFromNgbDate(ngDate);
    this.startDate = new Date(date.setDate(date.getDate()-date.getDay()));
    this.NgbStartDate = this.createNgbDateFromDate(this.startDate);
    this.endDate = new Date(new Date(this.startDate ).setDate(new Date(this.startDate ).getDate() + 6));
    this.NgbEndDate = this.createNgbDateFromDate(this.endDate);
    this.dateChange();
  }

  buildDateArray(){
    this.dateObjects = [];
    for(const dt=new Date(this.startDate); dt<=new Date(this.endDate); dt.setDate(dt.getDate()+1)){
         this.dateObjects.push(this.buildDateObj(dt));
    }
  }

  prevWeek(){
    this.startDate = new Date(new Date(this.startDate ).setDate(new Date(this.startDate ).getDate() - 7))
    this.NgbStartDate = this.createNgbDateFromDate(this.startDate);
    this.endDate = new Date(new Date(this.startDate ).setDate(new Date(this.startDate ).getDate() + 6));
    this.NgbEndDate = this.createNgbDateFromDate(this.endDate);
    this.dateChange();
  }

  nextWeek(){
    this.startDate = new Date(new Date(this.endDate).setDate(new Date(this.endDate ).getDate() +1))
    this.NgbStartDate = this.createNgbDateFromDate(this.startDate);
    this.endDate = new Date(new Date(this.startDate ).setDate(new Date(this.startDate ).getDate() + 6));
    this.NgbEndDate = this.createNgbDateFromDate(this.endDate);
    this.dateChange();
  }

  dateChange(){
    this._events = [];
    this.dateObjects = [];
    this.dateChangeOccurred.emit([this.startDate,this.endDate]);
    this.loaderService.display(true);
  }

  getEventsForDay(date:Date) : CalendarEventModel[]{
    let filteredEvents : CalendarEventModel[] = [];
    
    filteredEvents = (this._events.filter(x => (new Date(new Date(x.StartDateTime).setHours(0,0,0,0)).getTime() <= date.getTime()) && (new Date(new Date(x.EndDateTime).setHours(0,0,0,0)).getTime() >= date.getTime())));

    return filteredEvents;
  }

  eventSelectChange(event : CalendarEventModel){
    if(event.IsSelected){
      let currentSelection : Array<any> = this.dateObjects.filter(x => x.events.filter((y:CalendarEventModel) => (y.IsSelected == true) && (y.EventKey != event.EventKey)).length != 0);
      currentSelection.forEach(x=> {x.events.filter((y:CalendarEventModel)=> y.EventKey != event.EventKey).forEach((z:CalendarEventModel)=> z.IsSelected = false)});
      this.selectedEventChange.emit(event);
    }
    else{
      this.selectedEventChange.emit(null);
    }
  }
  
  buildDateObj(date:Date) : any{
    return {
      date: new Date(date),
      events: this.getEventsForDay(date),
    }
  }

  onDateSelection(date: NgbDate) {
    this.getRange(date);
  }

  isHovered(date: NgbDate) {
    return this.NgbStartDate && !this.NgbEndDate && this.hoveredDate && date.after(this.NgbStartDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.NgbEndDate && date.after(this.NgbStartDate) && date.before(this.NgbEndDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.NgbStartDate) || (this.NgbEndDate && date.equals(this.NgbEndDate)) || this.isInside(date) || this.isHovered(date);
  }

  createDateFromNgbDate(ngbDate: NgbDate): Date {
    return new Date(
                      ngbDate.year, 
                      ngbDate.month - 1, // Subtract 1 because NgbDate months are 1-based
                      ngbDate.day
                    );
  }

  createNgbDateFromDate(date: Date): NgbDate {
    return new NgbDate(
                        date.getFullYear(),
                        date.getMonth() + 1, // Add 1 because NgbDate months are 1-based
                        date.getDate()
                      );
  }

}
